import { createContext, useContext } from 'react'
import type { TripItineraryData } from 'tripPlanner/api/types'
import type { ItineraryScrollTarget } from '../hooks/useItineraryUpdates'

export interface ItineraryContextValue {
  itineraryData: TripItineraryData | undefined
  hasItineraryData: boolean
  enrichingStopIds: Set<number>
  enrichingItemIds: Set<number>
  scrollTarget: ItineraryScrollTarget | null
  clearScrollTarget: () => void
  refetchCurrentChatItinerary: () => void
  expandedStopIds: Set<number>
  setExpandedStopIds: React.Dispatch<React.SetStateAction<Set<number>>>
  handleToggleStopExpanded: (stopId: number, expanded: boolean) => void
}

export const ItineraryContext = createContext<ItineraryContextValue | null>(null)

export function useItineraryContext(): ItineraryContextValue {
  const ctx = useContext(ItineraryContext)
  if (!ctx) throw new Error('useItineraryContext must be used within TripPlannerChatProvider')
  return ctx
}
